import React, { useEffect, Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Activities from "./Activities";
import Customers from "./Customers";
import EconomyView from "./economy";
import SettingsView from "./settings";
import { fetchGlobalData } from "../../redux/globalData/globalDataSlice";
import Loader from "../../components/Loader";
// import Insurances from "./insurances/Insurances";
import Ambassador from "../../components/layout/Ambassador";
import Calculator from "../../components/layout/Calculator";
import GoodWorkingConditions from "./good_working_condition/GoodWorkingConditions";
import Freelancers from "./economy/Freelancers";
import { getTimeSheetData } from "../../redux/auth/authSlice";
import FeaturesPage from "components/features/FeaturesPage";
import HealthInsurance from "components/layout/outer-header/HealthInsurance";
import PensionInsurance from "components/layout/outer-header/PensionInsurance";
import PrivateCareInsurance from "components/layout/outer-header/PrivateCareInsurance";
import { LOCALES } from "common/constants";
import { lazyWithRetry } from "common/lazyWithRetry";

const InvoiceTool = lazyWithRetry(() => import("./settings/invoice-tool/InvoiceTool"));
const TimeSheet = lazyWithRetry(() => import("./settings/timesheet/TimeSheet"));
const Faq = lazyWithRetry(() => import("./Faq"));
const Insurances = lazyWithRetry(() => import("./insurances/Insurances"));

const DashboardView = ({ dashboardFooter }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);
  const { isLoading } = useSelector((state) => state.globalData);
  let language = localStorage.getItem("i18nextLng");

  useEffect(() => {
    if (user) {
      dispatch(fetchGlobalData());
    }
  }, [dispatch]);


  const getQueryParams = (query) => {
    return new URLSearchParams(query);
  };
  useEffect(() => {
    const isValid = localStorage.getItem("user");
    if (!user && !isValid) {

      const queryParams = getQueryParams(location.search);
      const invoiceNumber = queryParams.get("invoiceNumber");
      const isAuthorize = queryParams.get("isAuthorize") == "true";
      if (invoiceNumber && isAuthorize) {
        navigate(language === LOCALES.EN_US ? `/login?lang=${LOCALES.EN_US}&invoiceNumber=${invoiceNumber}&isAuthorizedForReminder=${true}` : `/logga-in?lang=${LOCALES.SV_SE}&invoiceNumber=${invoiceNumber}&isAuthorizedForReminder=${true}`);
      }
      else {
        navigate(language === LOCALES.EN_US ? `/login?lang=${LOCALES.EN_US}` : `/logga-in?lang=${LOCALES.SV_SE}`);
      }
    }
    if (
      location.pathname.includes("/dashboard/activities") ||
      location.pathname.includes("/instrumentbrada/aktiviteter") ||
      location.pathname.includes("/dashboard/economy/invoices") ||
      location.pathname.includes("/instrumentbrada/ekonomi/fakturor") ||
      location.pathname.includes("/dashboard/economy/created-time-sheets") ||
      location.pathname.includes(
        "/instrumentbrada/ekonomi/skapade-tidrapporter"
      )
    ) {
      dispatch(getTimeSheetData({}));
    }
  }, [user, navigate, location, dispatch, language]);

  return (
    <>
      {isLoading && <Loader />}
      <Routes>
        <Route
          exact
          path={language === LOCALES.EN_US ? "activities" : "aktiviteter"}
          element={<Activities />}
        />
        <Route exact path="customers" element={<Customers />} />
        <Route exact path="freelancers" element={<Freelancers />} />
        <Route
          exact
          path={language === LOCALES.EN_US ? "calculator-anchor" : "kalkylator-ankare"}
          element={<Calculator />}
        />
        <Route
          exact
          path={language === LOCALES.EN_US ? "invoice-tool" : "faktura-verktyg"}
          element={
            <Suspense
              fallback={
                <div>
                  <Loader />
                </div>
              }
            >
              <InvoiceTool dashboardFooter={dashboardFooter} />
            </Suspense>
          }
        />
        <Route
          exact
          path="faq"
          element={
            <Suspense
              fallback={
                <div>
                  <Loader />
                </div>
              }
            >
              <Faq />
            </Suspense>
          }
        />
        <Route
          exact
          path={language === LOCALES.EN_US ? "economy/*" : "ekonomi/*"}
          element={
            <Suspense
              fallback={
                <div>
                  <Loader />
                </div>
              }
            >
              <EconomyView />
            </Suspense>
          }
        />
        <Route
          exact
          path={language === LOCALES.EN_US ? "settings/*" : "installningar/*"}
          element={
            <Suspense
              fallback={
                <div>
                  <Loader />
                </div>
              }
            >
              <SettingsView />
            </Suspense>
          }
        />

        <Route exact path="ambassador" element={<Ambassador />} />
        <Route
          exact
          path={language === LOCALES.EN_US ? "function" : "funktion"}
          element={<FeaturesPage />}
        />

        <Route
          exact
          path={language === LOCALES.EN_US ? "health-insurance" : "sjukforsakring"}
          element={<HealthInsurance dashboardFooter={dashboardFooter} />}
        />

        <Route
          exact
          path={language === LOCALES.EN_US ? "pension" : "pension"}
          element={<PensionInsurance dashboardFooter={dashboardFooter} />}
        />

        <Route
          exact
          path={
            language === LOCALES.EN_US
              ? "private-healthcare-insurance"
              : "privatvardsforsakring"
          }
          element={<PrivateCareInsurance dashboardFooter={dashboardFooter} />}
        />

        <Route
          exact
          path={language === LOCALES.EN_US ? "insurances" : "forsakring"}
          // element={<Insurances />}
          element={
            <Suspense
              fallback={
                <div>
                  <Loader />
                </div>
              }
            >
              <Insurances />
            </Suspense>
          }
        />
        <Route
          exact
          path={
            language === LOCALES.EN_US ? "good-Working-conditions" : "bra-arbetsvillkor"
          }
          element={<GoodWorkingConditions />}
        />
        <Route
          exact
          path={language === LOCALES.EN_US ? "time-sheet" : "tidrapport"}
          element={
            <Suspense
              fallback={
                <div>
                  <Loader />
                </div>
              }
            >
              <TimeSheet dashboardFooter={dashboardFooter} />
            </Suspense>
          }
        />
        {/* <Route exact path="how-it-works" element={<HowItWorks />} /> */}
      </Routes>
    </>
  );
};

export default DashboardView;
